import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

function SearchTextField({ value, onChange, placeholder }) {
  const { t } = useTranslation('common');
  return (
    <div className="relative w-1/4">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-500" />
      </div>
      <input
        type="text"
        value={value}
        onChange={onChange}
        className="block w-full pl-10 pr-3 py-2 border border-transparent rounded-full leading-5 bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:bg-gray-100 focus:ring-2 focus:ring-gray-200 focus:border-transparent transition duration-300 ease-in-out shadow-md hover:bg-gray-100"
        placeholder={placeholder || t('search')}
      />
    </div>
  );
}

export default SearchTextField;